import { Injectable } from '@angular/core';
import {  v4 as uuidv4 } from 'uuid';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReferenceService {
  private referenceUUID : string;
  private showReferenceSubject = new BehaviorSubject<boolean | null>(null);
  showReference$ = this.showReferenceSubject.asObservable();
  constructor() {
    this.referenceUUID =  uuidv4();
  }
  setReferenceUUID(uuid: string): void {
    this.referenceUUID = uuid;
  }

  getReferenceUUID(): string {
    return this.referenceUUID || uuidv4();
  }
  setShowReference(showReference:boolean): void {
    this.showReferenceSubject.next(showReference);
  }
}
